import Image from '@base/FutureImage';
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import Tick from 'aquilla/icons/actions/Tick';
import Typography from 'aquilla/core/atoms/Typography';
import { useMemo } from 'react';

const NormalFlowIconicCardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${Spacings.SPACING_3B};
`;

const RightInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${Spacings.SPACING_2B};
`;

const InfoPoints = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: ${Spacings.SPACING_2};
`;

const StyImage = styled(Image)`
  border-radius: ${Spacings.SPACING_2B};
  min-width: 110px;
`;

const NormalFlowIconicCard = ({ iconicData }) => {
  const { appTitle = '', imageUrl = '' } = iconicData;

  const iconicMetaDataArray = useMemo(() => {
    const iconicMetaDataArray = [];
    iconicMetaDataArray.push(iconicData?.appDesc1);
    iconicMetaDataArray.push(iconicData?.appDesc2);
    iconicMetaDataArray.push(iconicData?.appDesc3);
    return iconicMetaDataArray;
  }, [iconicData?.appDesc1, iconicData?.appDesc2, iconicData?.appDesc3]);

  const iconicMetaData = iconicMetaDataArray.filter(
    (value) => value !== '' && value !== null
  );

  const isEmptyCard =
    appTitle === '' || imageUrl === '' || iconicMetaData?.length === 0;

  return isEmptyCard ? (
    <></>
  ) : (
    <NormalFlowIconicCardWrapper>
      <StyImage src={imageUrl} width={110} height={100} alt="Referral Ticket" />
      <RightInfoWrapper>
        <Typography variant="h6">{appTitle}</Typography>
        {iconicMetaData?.map((metaData) => {
          return (
            <InfoPoints key={metaData}>
              <Tick color="var(--color-i-gray-13)" width={16} height={16} />
              <Typography variant="p3" color="var(--color-i-gray-13)">
                {metaData}
              </Typography>
            </InfoPoints>
          );
        })}
      </RightInfoWrapper>
    </NormalFlowIconicCardWrapper>
  );
};

export default NormalFlowIconicCard;
